mod.modules.define("ScreenerAnalytics", "BaseAnalytics", function(fn) {

	fn.prototype.init = function(params) {
		this.category = "Screener";

		// Show that we landed on the page
		//this.trackPage(this.category);
	};

	// Disabling actions for business reasons

	//fn.prototype.observables = {
	//	"screener - add filter": function() {
	//		this.trackAction("Screener", "Add filter");
	//	},
	//	"screener - remove filter": function() {
	//		this.trackAction("Screener", "Remove filter");
	//	},
	//	"screener - reorder filters": function() {
	//		this.trackAction("Screener", "Reorder filters");
	//	},
	//	"screener - screen": function() {
	//		this.trackAction("Screener", "Screen");
	//	},
	//	"screener - launch expanded window": function() {
	//		this.trackAction("Screener", "Launch Expanded Window");
	//	}
	//};

});